import React, { useState } from 'react';
import { Button } from 'antd';
import { Col, Row } from 'reactstrap';
import Restaurants from './components/Restaurants';

const ExamplePage = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible1, setModalVisible1] = useState(false);

  return (
    <div className="dashboard-container">
      <Row>
        <Col md={12}>
          <div style={{justifyContent: 'space-between', display: 'flex'}}>
            <h3 className="page-title">Restaurants</h3>
            <Button type="text" onClick={() => setModalVisible(true)}>Add Restaurant</Button>
            <Button type="text" onClick={() => setModalVisible1(true)}>Import Excel</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Restaurants setModalVisible={(value) => setModalVisible(value)}
          setModalVisible1={(value) => setModalVisible1(value)}
          modalVisible={modalVisible}
          modalVisible1={modalVisible1} />
      </Row>
    </div>
  )
};

export default ExamplePage;
